// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"22f22143","796":"f2c70cbb"}[chunkId] + ".chunk.js";
};